module.exports = __webpack_public_path__ + "img/11.05427e66.jpg";